import Layout from "../../components/layOutWrapper/layOutWrapper";
import ExpenseReportRequestForm from "../../components/expenseReportRequests/expenseReportRequestForm"; 

export default function ExpenseReportRequestFormView () {
    return (
        <>
            <Layout children={<ExpenseReportRequestForm/>} sectionTitle="Enviar solicitud de rendición de gastos"/>
        </>
    )
}